import {Trans} from '@lingui/macro';
import React, {FC} from 'react';
import styled from 'styled-components';

import {HandlerOf} from '../../../../../libs/shared/helpers/src/react/reactHelpers';
import {buildRuleLibrarySearchUrl} from '../../../../settings/menu/settingsHelpers';
import {SetupGuideTask, SetupGuideTaskProps} from '../common/setupGuideTask';

/*
 * Constants.
 */

// Used by the Accounts Setup Guide to navigate to the Rules Library with "account" pre-filled.
const ruleLibraryAccountUrl = buildRuleLibrarySearchUrl('account');

/*
 * Props.
 */

type AddAccountRuleTaskProps = Omit<SetupGuideTaskProps, 'label' | 'onClick'> & {
  isUserGlobalAdmin: boolean;
  navigateToLink: HandlerOf<string>;
};

/*
 * Styles.
 */

const StyledTooltipDiv = styled.div`
  max-width: 220px;
`;

/*
 * Component.
 */

export const AddAccountRuleTask: FC<AddAccountRuleTaskProps> = ({
  isUserGlobalAdmin,
  isComplete,
  navigateToLink,
}) => (
  <SetupGuideTask
    label={<Trans id="accounts-setup-guide-task-add-account-rule">Add an account rule</Trans>}
    isComplete={isComplete}
    onClick={() => navigateToLink(ruleLibraryAccountUrl)}
    renderDisabledTooltip={isUserGlobalAdmin ? undefined : renderDisabledTooltip}
  />
);

/*
 * Helpers.
 */

function renderDisabledTooltip() {
  return (
    <StyledTooltipDiv>
      <Trans id="accounts-setup-guide-task-add-account-rule-disabled">
        Please reach out to your team admin to create rules using accounts
      </Trans>
    </StyledTooltipDiv>
  );
}
